'use strict';

function applyBackgroundOptions(target) {
  // BACKGROUND

  /**
   *  @prop {boolean} [background.enabled=false]
   * If true, plugin will send background/foreground events
   * Different device behaviour is settable in background.settings
   */
  target['background.enabled'] = true;

  /**
   *  @prop {string} [background.settings]
   * Action to do when the browser goes to background.
   * Options are 'stop', 'pause', and '' for no action.
   * stop will be used to stop the view and track post-foreground events in a new view
   * pause will be used when after foreground event, an action like pressing play button is expected to resume the content
   * '' will be used if the content can be played in background
   * If not defined, specific device options will be used
   * background.setings.android / background.settings.iOS / background.settings.desktop / background.settings.tv
   * Default specific device values are stop for android and iphone, nothing for desktop.
   */
  target['background.settings'] = undefined;

  /**
   *  @prop {string} [background.settings.android='stop']
   * If background.settings is not defined, action to do when the browser goes to background if
   * the device is android type.
   * Options are 'stop', 'pause', and '' or not defined for no action.
   * bg by default
   */
  target['background.settings.android'] = 'stop';

  /**
   *  @prop {string} [background.settings.iOS='stop']
   * If background.settings is not defined, action to do when the browser goes to background if
   * the device is iphone type.
   * Options are 'stop', 'pause', and '' or not defined for no action.
   * bg by default
   */
  target['background.settings.iOS'] = 'stop';

  /**
   *  @prop {string} [background.settings.desktop=null]
   * If background.settings is not defined, action to do when the browser goes to background if
   * the device is desktop type.
   * Options are 'stop', 'pause', and '' or not defined for no action.
   * Null by default
   */
  target['background.settings.desktop'] = undefined;

  /**
   *  @prop {string} [background.settings.tv='stop']
   * If background.settings is not defined, action to do when the browser goes to background if
   * the device is smartTV type.
   * Options are 'stop', 'pause', and '' or not defined for no action.
   * bg by default
   */
  target['background.settings.tv'] = 'stop';

  /**
   *  @prop {string} [background.settings.playstation='stop']
   * If background.settings is not defined, action to do when the browser goes to background if
   * the device is playstation type.
   * Options are 'stop', 'pause', and '' or not defined for no action.
   * Null by default
   */
  target['background.settings.playstation'] = 'stop';
}

module.exports = applyBackgroundOptions;

